<template>
  <div id="maintenance" class="h-100 d-flex flex-column mx-auto justify-content-center align-items-center" style="padding-top: 120px;">
        <!-- <h1 class="fw-bold" style="font-size: 200px;">Maintenance</h1>
        <div class="bottom-0">
          <p class="mt-2" style="font-size: x-large;">
            The Page You were looking for is on Maintenance. Let's get you <br>
            back <router-link to="/" class="text-underline text-secondary-theme">Home</router-link>
          </p>
        </div> -->
    </div>
</template>
